import { observable, action } from 'mobx'
import gApi from '@api/chang_su/consultGiftApi'
import { message } from 'hljd'
import { hashHistory } from 'react-router'
import { PRIVILEGE_CONSULT_GIFT } from '@constant'

class Store {
  @observable gift_content
  @observable gift_status
  @observable gift_reason

  @action
  getGift = async key => {
    let { data, success } = await gApi.getConsultGiftConfig({ id: key })
    if (success) {
      this.gift_content = data.content
      this.gift_reason = data.reason
    }
  }

  @action
  changeValue = e => {
    this.gift_content = e.target.value
    if (this.gift_content.length > 10) {
      this.gift_content = this.gift_content.substring(0, 10)
    }
  }

  @action
  saveGift = async () => {
    const { gift_content, gift_status } = this

    let patterns = /[^a-zA-Z0-9\u4E00-\u9FA5]/g

    if (!gift_content) {
      return message.warning('内容不能为空！')
    }

    if (patterns.test(gift_content)) {
      return message.warning('不可输入除中文，英文，数字外的其它符号！')
    }

    let params = {
      grade_privilege_id: PRIVILEGE_CONSULT_GIFT,
      content: gift_content,
      status: 1
    }

    let apiName
    if (gift_status == 0) {
      apiName = gApi.addConsultGiftConfig(params)
    } else {
      apiName = gApi.editConsultGiftConfig(params)
    }

    let { success } = await apiName
    if (success) {
      message.success('操作成功！')
      // window.location.href = '#/localMerchant/marketingTools?key=20'

      hashHistory.push(
        `/localMerchant/marketingTools?key=${PRIVILEGE_CONSULT_GIFT}`
      )
    }
  }
}
export default new Store()
